/** @jsx jsx */
import { jsx, css, keyframes } from '@emotion/core';

const bounce = keyframes`
  0%, 60%, 100% {
    transform: translateY(0);
    opacity: 0.7;
  }
  30% {
    transform: translateY(-10px);
    opacity: 1;
  }
`;

const TypingIndicator = () => {
  return (
    <div
      css={css`
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 8px 12px;
        height: auto;
        min-height: 16px;
      `}
    >
      <div
        css={css`
          display: flex;
          align-items: center;
          gap: 4px;
        `}
      >
        <div
          css={css`
            width: 8px;
            height: 8px;
            background-color: #9ca3af;
            border-radius: 50%;
            animation: ${bounce} 1.4s infinite;
            animation-delay: 0s;
          `}
        />
        <div
          css={css`
            width: 8px;
            height: 8px;
            background-color: #9ca3af;
            border-radius: 50%;
            animation: ${bounce} 1.4s infinite;
            animation-delay: 0.2s;
          `}
        />
        <div
          css={css`
            width: 8px;
            height: 8px;
            background-color: #9ca3af;
            border-radius: 50%;
            animation: ${bounce} 1.4s infinite;
            animation-delay: 0.4s;
          `}
        />
      </div>
    </div>
  );
};

export default TypingIndicator;
